// Libraries
import { AuthenticatorBuilder } from '@prove-identity/mobile-auth'

// Services
import api from '../api'

// Utilities
import { KeyConstants } from '../constants'
import DeviceUtil from './deviceUtil'
import isEmpty from './isEmpty'
import logger from './loggerUtil'
import Preference from './preferenceUtil'

let authenticator

const mobilePhoneVerifyUtil = {
  async authenticate (phoneNumber) {
    try {
      logger.info('Starting mobile phone verify authentication')
      initialize(phoneNumber)

      const response = await authenticator.authenticate()

      logger.info('Mobile phone verify authentication completed')
      logger.debug(JSON.stringify(response))

      if (!response?.success) {
        throw new Error('Failed to verify mobile phone')
      }
    } catch (error) {
      logger.error('Error attempting to mobile phone verify authenticate')
      logger.debug(error)
      throw error
    }
  }
}

export default mobilePhoneVerifyUtil

const initialize = (phoneNumber) => {
  logger.info('Initialization of Prove Mobile Authenticator')
  authenticator = new AuthenticatorBuilder()
    .withFetchImplementation()
    .withStartStep({
      execute: async () => {
        try {
          const sessionId = await Preference.get(KeyConstants.sessionId, '')
          const response = await api.user.initiatePhoneVerification(
            DeviceUtil.getIsMobileDevice() ? 'mobile' : 'desktop',
            phoneNumber,
            sessionId
          )

          if (isEmpty(response?.url)) {
            throw new Error('Failed to get auth link')
          }

          return {
            authUrl: response.url
          }
        } catch (error) {
          logger.error('Error attempting to run mobile phone verify start step')
          logger.debug(error)
          throw error
        }
      }
    })
    .withFinishStep({
      execute: async (input) => {
        try {
          const sessionId = Preference.get(KeyConstants.sessionId, '')
          await api.user.mobileAuthConfirmation(
            DeviceUtil.getIsMobileDevice ? 'mobile' : 'desktop',
            phoneNumber,
            sessionId,
            input.vfp
          )

          return {
            success: true
          }
        } catch (error) {
          logger.error('Error attempting to run mobile phone verify finish step')
          logger.debug(error)
          throw error
        }
      }
    })
    .build()
}
